import { getContactOptions } from '../../helpers/twHelper';

export const channelMapping = {
  EMAIL: 'email',
  PHONE: 'callus',
  COMMUNITY: 'community',
  RES_CENTER: 'seller',
  CHAT: 'chat',
  MESSAGE_US: 'message',
  CHAT_BOT: 'chatbot',
  SAC: 'scheduleCallBack',
};

export const contactChannelFilter = (contactOptions) => {
  if (!Array.isArray(contactOptions) || contactOptions.length <= 0 || Object.keys(contactOptions[0]).length === 0) {
    return null;
  }
  const mapping = channelMapping;

  // Contact opions parser and validation
  return contactOptions.map((channel) =>
    channel.name && mapping[channel.name] && channel.rank
      ? {
          type: mapping[channel.name],
          priority: `${channel.rank}`,
        }
      : {},
  );
};

export const getDefaultContactOptions = () => {
  return contactChannelFilter(getContactOptions());
};
